import styled from "styled-components";

export const Wrapper = styled.div`
  width: 530px;
`;

export const Key = styled.span`
  color: ${(props) => props.theme.colors.green[300].accent};
  padding: 0 4px;
`;
